// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"NA1_TheComp__91qE_"};